import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import shopErrors from '~/services/shop/errors';
import { getUrl } from '~/services/shop/utils';

export default async function setBasketVoucher(
    basketReference: string | undefined,
    couponCode: string,
    email?: string,
) {
    if (!basketReference) {
        return Promise.reject(new Error(shopErrors.referenceNotFound.message));
    }

    const addEmailQuery = email ? `?email=${encodeURIComponent(email)}` : '';
    const endpoint = `/baskets/${basketReference}/voucher/${couponCode}${addEmailQuery}`;
    const voucherReturn = await shop
        .post(getUrl(endpoint), {
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .json<ShopTypes.BasketResponse>();

    return voucherReturn;
}
